import * as Sentry from '@sentry/browser';

/*******************************************************************************
 * sentryHttpInterceptorFactory */
/**
 * Returns an HTTP interceptor that reports server (5xx) errors to Sentry.
 *******************************************************************************/
/* @ngInject */ export function sentryHttpInterceptorFactory($q) {
  return {
    responseError: function (rejection) {
      if (!SENTRY_DSN) return $q.reject(rejection);

      // Capture server errors only. 4xx responses are expected application behavior
      // (validation failures, auth errors) and would generate noise in Sentry.
      if (rejection.status >= 500) {
        Sentry.withScope((scope) => {
          scope.setContext('HTTP Error', {
            url: rejection.config?.url,
            method: rejection.config?.method,
            status: rejection.status,
            statusText: rejection.statusText
          });
          Sentry.captureMessage(
            `HTTP ${rejection.status}: ${rejection.config?.method} ${rejection.config?.url}`,
            'error'
          );
        });
      }

      return $q.reject(rejection);
    }
  };
}
